
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import bookDemo from './demo/book.twig';
import eventDemo from './demo/event.twig';
// The '!!raw-loader!' syntax is a non-standard, Webpack-specific, syntax.
// See: https://github.com/webpack-contrib/raw-loader#examples
// For now, it seems likely Storybook is pretty tied to Webpack, therefore, we are
// okay with the following Webpack-specific raw loader syntax. It's better to leave
// the ESLint rule enabled globally, and only thoughtfully disable as needed (e.g.
// within a Storybook docs page and not within an actual component).
// This can be revisited in the future if Storybook no longer relies on Webpack.
// eslint-disable-next-line @cloudfour/import/no-webpack-loader-syntax
import bookDemoSource from '!!raw-loader!./demo/book.twig';
// eslint-disable-next-line @cloudfour/import/no-webpack-loader-syntax
import eventDemoSource from '!!raw-loader!./demo/event.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Components/Media Summary" mdxType="Meta" />
    <h1>{`Media Summary`}</h1>
    <p>{`The Media Summary components extends `}<a parentName="p" {...{
        "href": "/docs/objects-media--image"
      }}>{`the Media object`}</a>{` with functionality specific to linked content summaries.`}</p>
    <h2>{`Examples`}</h2>
    <p>{`An event summary with `}<a parentName="p" {...{
        "href": "/docs/components-calendar-date--basic"
      }}>{`a Calendar Date component`}</a>{` as its object:`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Event" parameters={{
        docs: {
          source: {
            code: eventDemoSource
          }
        }
      }} mdxType="Story">
    {args => eventDemo(args)}
  </Story>
    </Canvas>
    <p>{`A book summary that uses `}<a parentName="p" {...{
        "href": "/docs/objects-media--image"
      }}>{`Media object properties`}</a>{` to adjust its layout:`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Book" parameters={{
        docs: {
          source: {
            code: bookDemoSource
          }
        }
      }} mdxType="Story">
    {args => bookDemo(args)}
  </Story>
    </Canvas>
    <h2>{`Template Properties`}</h2>
    <p>{`All `}<a parentName="p" {...{
        "href": "/docs/objects-media--image"
      }}>{`Media object`}</a>{` properties are supported, along with the following unique properties:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`heading`}</inlineCode>{` (string): Content for the heading. Also available as a block.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`heading_class`}</inlineCode>{` (string): Sets the `}<inlineCode parentName="li">{`class`}</inlineCode>{` property of `}<a parentName="li" {...{
          "href": "/docs/components-heading--example"
        }}>{`the Heading component`}</a>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`heading_id`}</inlineCode>{` (string): Sets the `}<inlineCode parentName="li">{`id`}</inlineCode>{` property of `}<a parentName="li" {...{
          "href": "/docs/components-heading--example"
        }}>{`the Heading component`}</a>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`heading_level`}</inlineCode>{` (string, default `}<inlineCode parentName="li">{`3`}</inlineCode>{`): Sets the `}<inlineCode parentName="li">{`level`}</inlineCode>{` property of `}<a parentName="li" {...{
          "href": "/docs/components-heading--example"
        }}>{`the Heading component`}</a>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`heading_tag_name`}</inlineCode>{` (string): Sets the `}<inlineCode parentName="li">{`tag_name`}</inlineCode>{` property of `}<a parentName="li" {...{
          "href": "/docs/components-heading--example"
        }}>{`the Heading component`}</a>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`heading_weight`}</inlineCode>{` (string): Sets the `}<inlineCode parentName="li">{`weight`}</inlineCode>{` property of `}<a parentName="li" {...{
          "href": "/docs/components-heading--example"
        }}>{`the Heading component`}</a>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`href`}</inlineCode>{` (string): The URL to link to if the heading has content.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`rhythm`}</inlineCode>{` (string, default `}<inlineCode parentName="li">{`"compact"`}</inlineCode>{`): Sets the amount of `}<a parentName="li" {...{
          "href": "/docs/objects-rhythm--example"
        }}>{`vertical rhythm`}</a>{` for the heading and content.`}</li>
    </ul>
    <h2>{`Template Blocks`}</h2>
    <p>{`All `}<a parentName="p" {...{
        "href": "/docs/objects-media--image"
      }}>{`Media object`}</a>{` blocks are supported, along with the following unique blocks:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`heading`}</inlineCode>{`: Content for the heading. Also available as a property.`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const event = (args => eventDemo(args));
event.storyName = 'Event';
event.parameters = { storySource: { source: 'args => eventDemo(args)' }, ...{
  docs: {
    source: {
      code: eventDemoSource
    }
  }
} };

export const book = (args => bookDemo(args));
book.storyName = 'Book';
book.parameters = { storySource: { source: 'args => bookDemo(args)' }, ...{
  docs: {
    source: {
      code: bookDemoSource
    }
  }
} };

const componentMeta = { title: 'Components/Media Summary', includeStories: ["event","book"],  };

const mdxStoryNameToKey = {"Event":"event","Book":"book"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;